import ArticleIcon from '@mui/icons-material/Article';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import FilterListIcon from '@mui/icons-material/FilterList';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentOutlined';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import SpeedIcon from '@mui/icons-material/Speed';
import ForumIcon from '@mui/icons-material/Forum';
import ViewKanbanOutlinedIcon from '@mui/icons-material/ViewKanbanOutlined';
import CallToActionIcon from '@mui/icons-material/CallToAction';

// constant
const icons = {
    SpeedIcon,
    PeopleOutlineIcon,
    ArticleIcon,
    ViewKanbanOutlinedIcon,
    FactCheckOutlinedIcon,
    FilterListIcon,
    ModeCommentOutlinedIcon,
    ContactSupportIcon,
    ForumIcon,
    ConfirmationNumberOutlinedIcon,
    CallToActionIcon
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const other = {
    id: 'sample-docs-roadmap',
    type: 'group',
    children: [
        {
            id: 'dashboard/default',
            title: 'My Dashboard',
            type: 'item',
            url: 'dashboard/default',
            accessId: 'MY_DASHBOARD',
            icon: icons.SpeedIcon,
            breadcrumbs: false
        },
        {
            id: 'open-close-tickets',
            title: 'My Tickets',
            type: 'item',
            url: 'open-close-tickets',
            accessId: 'MY_TICKETS',
            icon: icons.FactCheckOutlinedIcon,
            breadcrumbs: false
        },
        {
            id: 'member-priority',
            title: 'Member Priority',
            type: 'item',
            url: 'member-priority',
            accessId: 'MEMBER_PRIORITY_DASHBOARD',
            icon: icons.ViewKanbanOutlinedIcon,
            breadcrumbs: false
        },
        {
            id: 'requirement-funnel',
            title: 'Requirement Funnel',
            type: 'item',
            url: 'requirement-funnel',
            accessId: 'REQUIREMENT_FUNNEL',
            icon: icons.FilterListIcon,
            breadcrumbs: false
        },
        {
            id: 'member-list',
            title: 'Member List',
            type: 'item',
            url: 'member-list',
            accessId: 'MEMBER_LIST',
            icon: icons.PeopleOutlineIcon,
            breadcrumbs: false
        },
        {
            id: 'booking-list',
            title: 'Booking List',
            type: 'item',
            url: 'booking-list',
            accessId: 'BOOKING_LIST',
            icon: icons.ArticleIcon,
            breadcrumbs: false
        },
        {
            id: 'create-quote',
            title: 'Create Quotes',
            type: 'item',
            url: 'create-quote',
            accessId: 'CREATE_QUOTES',
            icon: icons.ModeCommentOutlinedIcon,
            breadcrumbs: false
        },
        {
            id: 'booking-requests',
            title: 'Booking Requests',
            type: 'item',
            url: 'booking-requests',
            accessId: 'BOOKING_REQUEST',
            icon: icons.ContactSupportIcon,
            breadcrumbs: false
        },
        {
            id: 'internal-commenting',
            title: 'Conversations',
            type: 'item',
            url: 'internal-commenting',
            accessId: 'INTERNAL_QUERIES',
            icon: icons.ForumIcon,
            breadcrumbs: false
        },
        {
            id: 'package-bookings',
            title: 'Holidays PBO',
            type: 'item',
            url: 'package-bookings',
            accessId: 'PACKAGE_BOOKINGS',
            icon: icons.ConfirmationNumberOutlinedIcon,
            breadcrumbs: false
        }
        // {
        //     id: 'package-bookings-New',
        //     title: 'Holidays PBO Old',
        //     type: 'item',
        //     url: 'booking-list-old/tkgn3',
        //     accessId: 'PACKAGE_BOOKINGS',
        //     icon: icons.CallToActionIcon,
        //     breadcrumbs: false
        // }
    ]
};

export default other;
